function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "95DECAAF-1720-4DF0-925D-5528EE3D5C7B@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Homepage_new_1280",
  transform: "translate(-133.000000, -2873.000000)",
  fill: "#8396C8",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-23",
  transform: "translate(121.000000, 2832.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "quotation-marks",
  transform: "translate(12.000000, 41.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.62326007,9.92032967 C7.01556777,7.4543956 10.0979853,4.82032967 12.5078755,4.76428571 C12.6760073,4.76428571 12.8441392,4.70824176 12.9562271,4.59615385 C13.068315,4.54010989 13.1804029,4.48406593 13.2364469,4.31593407 C14.0771062,2.7467033 13.6287546,1.51373626 12.2276557,0.504945055 C10.602381,-0.671978022 8.02435897,0.504945055 6.73534799,1.56978022 C3.48479853,4.25989011 0.178205128,8.91144689 0.346336996,13.339011 C-0.214102564,16.3094322 -0.102014652,19.5038462 0.738644689,22.1379121 C1.29908425,23.8192308 2.92435897,24.6598901 4.60567766,24.771978 C6.28699634,24.8841575 9.76172161,25.3884615 11.2749084,24.3797619 C12.7880952,23.3708791 12.9001832,21.4093407 13.068315,19.7281136 C13.2364469,17.878663 13.7408425,14.4038462 12.1716117,12.9467033 C10.602381,11.5456044 6.11886447,13.0587912 6.62326007,9.92032967 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.1177656,9.92032967 C25.5100733,7.4543956 28.5923993,4.82032967 31.002381,4.76428571 C31.1705128,4.76428571 31.3386447,4.70824176 31.4507326,4.59615385 C31.5629121,4.54010989 31.6749084,4.48406593 31.731044,4.31593407 C32.5717033,2.7467033 32.1233516,1.51373626 30.7222527,0.504945055 C29.096978,-0.671978022 26.518956,0.504945055 25.2298535,1.56978022 C21.979304,4.25989011 18.6727106,8.91153846 18.8408425,13.339011 C18.2804029,16.3094322 18.3924908,19.5038462 19.2330586,22.1379121 C19.7934982,23.8192308 21.4187729,24.6598901 23.1001832,24.771978 C24.7815018,24.8841575 28.2562271,25.3884615 29.7694139,24.3797619 C31.2825092,23.3708791 31.3946886,21.4093407 31.5628205,19.7281136 C31.7309524,17.878663 32.235348,14.4038462 30.6661172,12.9467033 C29.0968864,11.5456044 24.557326,13.0587912 25.1177656,9.92032967 Z",
  id: "Shape"
})))));

var SvgDoubleQuotes = function SvgDoubleQuotes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "25px",
    viewBox: "0 0 33 25",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-quotes.b430ae15.svg";
export { ForwardRef as ReactComponent };